import { registerPropertyManagerSection } from '@/core';
import ExtrudePropertySection from '@/components/editor/property-manager/extrude/ExtrudePropertySection.vue';

registerPropertyManagerSection({
  id: 'extrude-boss',
  title: (context) => context.extrudeOperation === 'cut' ? '切除-拉伸' : '凸台-拉伸',
  order: 30,
  component: ExtrudePropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.extrudeCanSubmit === false,
  isApplicable: (context) => {
    if (context.activeCommand === 'extrude' || context.activeCommand === 'extrude-cut') {
      return true;
    }
    return Boolean(context.extrudeActive);
  },
  onConfirm: (context) => {
    context.onConfirm?.();
  },
  onCancel: (context) => {
    context.cancelExtrude?.();
  },
});
